import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/brands/new/loading';

export const Route = createFileRoute('/_private/settings/brands/new')({
  component: Loading,
});
